import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from '@app/services/auth/auth.service';
import { AppRoutes } from '@app/utils/enums/routes.enum';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-main-banner',
  standalone: true,
  imports: [TranslateModule, RouterModule],
  templateUrl: './main-banner.component.html',
  styleUrl: './main-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainBannerComponent {
  public readonly appRoutes = AppRoutes;
  protected readonly isLoggedIn = inject(AuthService).isLoggedIn;
}
